'use client';

import { useFeatureGate, useGateValue } from '@statsig/react-bindings';
import { redirect } from 'next/navigation';

import useScrollTracking from '@/app/hooks/useScrollTracking';

import HealthPanelsSection from './_components/HealthPanelsSection';
import IntegrationsAllIntegrations from './_components/IntegrationsAllIntegrations';
import IntegrationsAppCards from './_components/IntegrationsAppCards';
import IntegrationsApps from './_components/IntegrationsApps';
import IntegrationsFooterCta from './_components/IntegrationsFooterCta';
import IntegrationsHero from './_components/IntegrationsHero';
import IntegrationsJumbotron from './_components/IntegrationsJumbotron';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  const integrationsPageEnabled = useFeatureGate(
    'integrations_page_rollout',
  ).value;
  const isBiomarkersEnabled = useGateValue('biomarkers_rollout');

  if (!integrationsPageEnabled) {
    return redirect('/404');
  }

  return (
    <>
      <IntegrationsHero />
      {isBiomarkersEnabled && <HealthPanelsSection />}
      <IntegrationsApps />
      <IntegrationsAppCards />
      <IntegrationsAllIntegrations />
      <IntegrationsJumbotron />
      <IntegrationsFooterCta />
    </>
  );
};

export default Content;
